module.exports = __webpack_public_path__ + "static/media/GOSTUDY_HorizontalUsage_Black_250x50.e4b6ab8f.png";